/**
 * Responsive textarea min-height breakpoints (mirrors ChatPill.css).
 */
export const TEXTAREA_MIN_HEIGHT = {
    mobile: 24, // ≤575px
    tablet: 36, // ≤991px
    desktop: 48,
};

/** Returns the correct min-height (px) for the full BiliChat page based on viewport. */
export function getTextareaMinHeight() {
    if (window.innerWidth <= 575) return TEXTAREA_MIN_HEIGHT.mobile;
    if (window.innerWidth <= 991) return TEXTAREA_MIN_HEIGHT.tablet;
    return TEXTAREA_MIN_HEIGHT.desktop;
}

/** Widget always uses a compact fixed size regardless of viewport. */
export const WIDGET_TEXTAREA = { minPx: 36, maxPx: 80 };

/**
 * Auto-expands a textarea ref based on content (ChatGPT-style height:auto trick).
 * Clamps between minPx and maxPx, enables scrolling when content exceeds max.
 */
export function autoExpandTextarea(ref, value, minPx, maxPx) {
    if (!ref.current) return;
    if (!value) {
        ref.current.style.height = `${minPx}px`;
        ref.current.style.overflowY = 'hidden';
        return;
    }
    ref.current.style.overflowY = 'hidden';
    ref.current.style.height = '1px';
    const scrollH = ref.current.scrollHeight;
    ref.current.style.height = `${Math.max(minPx, Math.min(scrollH, maxPx))}px`;
    ref.current.style.overflowY = scrollH > maxPx ? 'auto' : 'hidden';
}

/** Resets a textarea ref to its minimum height. */
export function resetTextareaHeight(ref, minPx) {
    if (!ref.current) return;
    ref.current.style.height = `${minPx}px`;
    ref.current.style.overflowY = 'hidden';
}
